<template>
  <main class="main">
    <router-link
      v-for="(item, index) in publications.data"
      :key="item.uid"
      :to="{ name: 'publication', params: { id: item.uid } }"
      ><span class="indent">{{ index + 1 }}</span
      >{{ item.title }}</router-link
    >
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "publications",
  metaInfo() {
    return {
      title: "- Publications"
    };
  },
  computed: mapState(["publications"])
};
</script>

<style lang="scss" scoped>
a {
  display: block;
}
.indent {
  width: 5rem;
  display: inline-block;
  @media only screen and (max-width: 768px) {
    width: 7rem;
  }
}
</style>
